export enum RentalPackages {
    FullPackages = 0,
    AudioPackages = 1,
    LightningPackages = 2,
    IndividualEquipment = 3
}